import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { Observable } from 'rxjs';

import { Controltype, Vraag, Vraagtype } from '@models/claims';
import { VraagboomAntwoord, IBaseVraagboomResultaat, SchademeldenState, Meetgegevens, VraagboomSelectieResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { Devicetype } from '../../../models/imports/generic';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { WindowService } from '../../../services/window-service';
import { VraagHelper } from '@services/public_api';
import { BaseOlsControlDirective } from '../../base/base-ols-control';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-vraag-control-summary',
  templateUrl: './vraag-control-summary.component.html',
  styleUrls: ['./vraag-control-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VraagControlSummaryComponent extends BaseOlsControlDirective implements OnInit {
  @Input() antwoordResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];
  @Input() status: SchademeldenState;
  @Input() currentVraag: Vraag;
  @Input() showtable: Boolean;
  @Output() wijzigenClicked: EventEmitter<VraagboomAntwoord<IBaseVraagboomResultaat>>
    = new EventEmitter<VraagboomAntwoord<IBaseVraagboomResultaat>>();
  private controltype = Controltype;
  private vraagtype = Vraagtype;
  _meetgegevens: Meetgegevens;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  alleResultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];

  constructor(
    private _dataService: DataService,
    private _windowService: WindowService
  ) { super(); }

  ngOnInit() {
    this._meetgegevens = this._dataService.getMeetgegevens();
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.alleResultaten = res;
        }
      });
  }

  geefVolgnr(id: string, reeks: Vraag[]): string {
    const vragenOfSummary: Vraag[] = reeks.filter(v => v.tonen);
    const volgnummer: number = vragenOfSummary.findIndex(v => v.id === id) + 1;
    return '-' + volgnummer.toString();
  }

  geefMeetidWijzigen(resultaat: VraagboomAntwoord<IBaseVraagboomResultaat>): string {
    if (!resultaat || !resultaat.vraag) {
      return null;
    }
    let _titel: string;
    let _plusSamenvattingVolgr = '';

    if (this.status === SchademeldenState.Samenvatting) {
      _titel = MetenMapper.format(this.currentVraag.titel);
      _plusSamenvattingVolgr = this.geefVolgnr(resultaat.vraag.id, this._meetgegevens.reeks);
    } else {
      _titel = MetenMapper.format(resultaat.vraag.titel);
    }

    return 'ipoclick-btn-' + this._dataService.getMeetidPazaProces() + '-' +
      this._meetgegevens.status + this._meetgegevens.sleutel + MetenMapper.geefVolgnr(resultaat.vraag, this._meetgegevens.reeks)
      + '_' + _titel + '-wijzigen' + _plusSamenvattingVolgr;
  }

  geefTitel(vraag: Vraag, gebruikStappenplankop: boolean): string {
    let titel = vraag.titel;
    if (gebruikStappenplankop) {
      let resultaatVraag = this.alleResultaten.find(ar => ar.vraag.id === vraag.id);
      if (resultaatVraag && resultaatVraag.antwoorden?.length > 0 && resultaatVraag.antwoorden[0].stappenplan_kop?.length > 0) {
        titel = resultaatVraag.antwoorden[0].stappenplan_kop;
      }
    }
    return VraagHelper.geefTitel(titel, this.alleResultaten);
  }

  isTekstregels(vraag: Vraag): boolean {
    if (vraag.control === Controltype.ContactGegevens || vraag.control === Controltype.TekstRegel) {
      return vraag.antwoorden?.length > 1;
    }
    return false;
  }

  tekstWijzigen(): string {
    if (this._windowService.deviceType() > Devicetype.TabletPortrait) {
      return 'Wijzigen';
    }
    return '';
  }

  wijzigen(resultaat: VraagboomAntwoord<IBaseVraagboomResultaat>): void {
    this.wijzigenClicked.emit(resultaat);
  }
}
